import Vue from 'vue';
import config from '@/config';

// TODO: https://medium.com/canariasjs/vue-api-calls-in-a-smart-way-8d521812c322

export default {
    /**
     * Requête pour authentifier un utilisateur
     *
     * @author Fabien Bellanger
     * @param {Object} data
     * @return {Promise}
     */
    postLogin(data)
    {
        return new Promise((resolve, reject) =>
        {
            Vue.http.post(config.baseApiUrl + '/auth/login', data)
                .then((response) =>
                {
                    resolve(response);
                })
                .catch((response) =>
                {
                    reject(response);
                });
        });
    },
};
